import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import routes from './routes';
import { unformatUrl,formaturl  } from '../config/staticData';
import api from './setAxios';

const Breadcrumbs = ({ blogID }) => {
    const location = useLocation();
    const basePath = '/blog'; 
    const filterPaths = ['hashtag', 'category', 'Category', 'search', 'blogcategory', 'blogCategory'];
    const pathnames = location.pathname.replace(basePath, '').split('/').filter(x => x && !filterPaths.includes(x));

    const [categoryTitle, setCategoryTitle] = useState(null);
    const [categoryId, setCategoryId] = useState(null);

    const fetchCategory = useCallback(async (blogID) => {
        try {
            const categoryResult = await api.get(`Blog/GetCategoryBlog/${blogID}`);
            if (categoryResult && Object.keys(categoryResult.data).length > 0) {
                setCategoryTitle(categoryResult.data.title);
                setCategoryId(categoryResult.data.id);
            } else {
                setCategoryTitle(null);
            }
        } catch (error) {
            console.error("خطا در دریافت کتگوری:", error);
            setCategoryTitle(null);
        } 
    }, []);

    useEffect(() => {
        if (blogID) {
            fetchCategory(blogID);
        } else {
            setCategoryTitle(null);
        }
    }, [blogID, fetchCategory]);

    const breadcrumbItems = pathnames.map((path, index) => {
        const url = `${basePath}/${pathnames.slice(0, index + 1).join('/')}`;

        let title;
        if (path === 'new') {
            title = 'جدیدترین مطالب';
        } else if (!isNaN(path) && categoryTitle) {
            title = categoryTitle;
        } else {
            const route = routes.find(r => r.path === url);
            title = route ? route.title : decodeURIComponent(path);
        }

        if (!isNaN(path) && index !== pathnames.length - 1) {
            return null; // مخفی کردن ID در مسیر breadcrumb
        }

        return { url, title, categoryTitle: categoryTitle || null };
    }).filter(item => item !== null); 

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {breadcrumbItems.length > 0 && (
                    <li className="breadcrumb-item"><Link to={basePath}>خانه</Link></li>
                )}
                {breadcrumbItems.map((item, index) => (
                    <React.Fragment key={item.url}>
                        {item.categoryTitle && (
                            <li className="breadcrumb-item">
                                <Link to={`${process.env.REACT_APP_BASE_PATH}/blogCategory/${categoryId}/${formaturl(item.categoryTitle)}`} target='_blank' >
                                    {unformatUrl(item.categoryTitle)}
                                </Link>
                            </li>
                        )}
                        <li className="breadcrumb-item">
                            {index === breadcrumbItems.length - 1 ? (
                                <span>{unformatUrl(item.title)}</span>
                            ) : (
                                <Link to={item.url}>{unformatUrl(item.title)}</Link>
                            )}
                        </li>
                    </React.Fragment>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
